import { render, staticRenderFns } from "./SpaQuanYunJu.vue?vue&type=template&id=8f8b4876&scoped=true"
import script from "./SpaQuanYunJu.vue?vue&type=script&lang=js"
export * from "./SpaQuanYunJu.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/roomdetail.css?vue&type=style&index=0&id=8f8b4876&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8b4876",
  null
  
)

export default component.exports